<template>
    <!-- Preloader Start -->
    <div class="acr-preloader" id="loading-bg">
        <img src="@/assets/images/henza.svg" alt="هنزاگلد" width="170px" height="120px">
        <div class="acr-preloader-inner">
            <div class="lds-grid" >
                <div ></div>
                <div ></div>
                <div ></div>
            </div>
        </div>
    </div>
    <!-- Preloader End -->
</template>
<script>
    export default {
        methods:{
            togglePreLoader(flag){
                const appLoading = document.getElementById('loading-bg')
                if(appLoading){
                    if ( flag === "open" && appLoading.classList.contains('hidden')) {
                        appLoading.classList.toggle('hidden')
                    }
                    else if( flag === "close" && !appLoading.classList.contains('hidden')){
                        appLoading.classList.toggle('hidden')
                    }
                }
            }
        }
    }
</script>